import * as React from 'react';
export const IcMoversPackers = (
  props: React.SVGProps<SVGSVGElement>
): JSX.Element => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M22 14v-1.53a3.26 3.26 0 00-.32-1.34l-1.24-2.47A3 3 0 0017.76 7H16V6a2 2 0 00-2-2h-2v5a1 1 0 01-.62.92.84.84 0 01-.38.08.999.999 0 01-.71-.29L9 8.41l-1.29 1.3a1 1 0 01-1.09.21A1 1 0 016 9V4H4a2 2 0 00-2 2v10a2 2 0 002 2h.18a3 3 0 005.64 0h4.36a3 3 0 005.64 0H20a2 2 0 002-2v-2zM7 18a1 1 0 110-2 1 1 0 010 2zm10 0a1 1 0 110-2 1 1 0 010 2zm-1-6V9h1.76a1 1 0 01.89.55L19.88 12H16z'
      fill='currentColor'
    />
  </svg>
);
